export default class {
  constructor(videoUrl, width, height, landingPage, lowerHeight=false) {
    const MIN_HEIGHT = (lowerHeight) ? 180 : 220;
    this.videoUrl = videoUrl; //facebook livestream url {string}
    this.width = width > 220 ? width : 220; // player width {string}; at least 220px!!
    this.height = height > MIN_HEIGHT ? height : MIN_HEIGHT; // player height {string}
    this.landingPage = landingPage;
    this.appId = "387587879006742";
  }
  init() {
    console.log("createFbStream");
    this._initFbAsyncInit();
    const wrapper = this._createElementWithAttribute("div");
    this._addStyle(wrapper, {
      width: `${this.width}px`,
      height: `${this.height}px`,
    });
    const fbRoot = this._createElementWithAttribute("div", { id: "fb_root" });
    const fbScript = this._createElementWithAttribute("script", {
      async: true,
      defer: true,
      src: `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2&appId=${
        this.appId
      }`,
    });
    fbScript.onload = this._initEmbeddedPlayerApiInstance; //make sure javascript is loaded
    const player = this._initEmbeddedPlayer();
    if (this.landingPage) {
      const landingPageEle = this._initLandingPage();
      wrapper.appendChild(landingPageEle);
    }
    wrapper.appendChild(fbRoot);
    wrapper.appendChild(fbScript);
    wrapper.appendChild(player);
    return wrapper;
  }
  _initLandingPage() {
    let landingPageEle = this._createElementWithAttribute("a", {
      href: this.landingPage,
      target: "_blank",
    });
    this._addStyle(landingPageEle, {
      display: "inline-block",
      width: `${this.width}px`,
      height: `${this.height}px`,
      position: "absolute",
      top: "0px",
      left: "0px",
      zIndex: "2",
    });
    return landingPageEle;
  }
  _createElementWithAttribute(type, attributeObj = {}, dataSetObj = {}) {
    const element = document.createElement(type);
    const keys = Object.keys(attributeObj);
    keys.forEach((res) => (element[res] = attributeObj[res]));
    const dataSetKeys = Object.keys(dataSetObj);
    dataSetKeys.forEach((res) => {
      element.dataset[res] = dataSetObj[res];
    });
    return element;
  }
  _initEmbeddedPlayer() {
    const player = this._createElementWithAttribute(
      "div",
      {
        className: "fb-video",
      },
      {
        href: this.videoUrl,
        width: `${this.width}px`,
        height: `${this.height}px`,
        showText: "false",
        autoplay: "true",
      }
    );
    this._addStyle(player, {
      height: `${this.height}px`,
      width: `${this.width}px`,
      display: `absolute`,
    });
    const fbXfbml = this._createElementWithAttribute("div", {
      className: "fb-xfbml-parse-ignore",
    });
    const blockQuote = this._createElementWithAttribute("blockquote", {
      cite: this.videoUrl,
    });
    fbXfbml.appendChild(blockQuote);
    player.appendChild(fbXfbml);
    return player;
  }
  _addStyle(element, styleObj = {}) {
    const keys = Object.keys(styleObj);
    keys.forEach((res) => (element.style[res] = styleObj[res]));
  }
  _initFbAsyncInit() {
    window.fbAsyncInit = function() {
      FB.init({
        appId: this.appId,
        xfbml: true,
        version: "v3.2",
      });
    };
  }
  _initEmbeddedPlayerApiInstance() {
    let my_video_player;
    FB.Event.subscribe("xfbml.ready", function(msg) {
      if (msg.type === "video") {
        my_video_player = msg.instance;
      }
    });
  }
}
